module.exports = __webpack_public_path__ + "news_02.jpg?7516d526f4a74821c439ddcaf818969c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/news_02.jpg
// module id = 634
// module chunks = 0